export default {
    init: function () {
        // Check if we're using the new radio-based accordion
        const accordionRadios = document.querySelectorAll('.accordion-radio');

        if (accordionRadios.length) {
            // This is the new radio-based accordion

            // Function to handle both click and mouseover events
            const handleInteraction = function(event) {
                // Prevent default to avoid issues with label clicking
                if (event.type === 'click') {
                    // Click is already handled by the radio button
                    return;
                }

                // For mouseover, check the corresponding radio
                const radioId = this.getAttribute('for');
                if (radioId) {
                    const radio = document.getElementById(radioId);
                    if (radio) {
                        radio.checked = true;
                    }
                }
            };

            // Get all accordion item labels
            const accordionLabels = document.querySelectorAll('.horizontal-accordion__content label.accordion-item');

            // Add event listeners for mouseover
            accordionLabels.forEach(label => {
                label.addEventListener('mouseover', handleInteraction);
            });

            return;
        }

        // If no radio buttons found, fall back to the original implementation
        const accordionTitles = document.querySelectorAll('.accordion-item-title');

        if (!accordionTitles.length) return;

        // Function to handle both click and mouseover events (original implementation)
        const handleInteraction = function(event) {
            // Find the parent accordion content
            const accordionContent = this.closest('.vertical-accordion__content');
            if (!accordionContent) return;

            // Remove active class from all accordion items
            const allItems = accordionContent.querySelectorAll('.accordion-item');
            allItems.forEach(item => item.classList.remove('active'));

            // Remove hide class from all titles
            const allTitles = accordionContent.querySelectorAll('.accordion-item-title');
            allTitles.forEach(title => title.classList.remove('hide'));

            // Add active class to the parent accordion item
            const parentItem = this.closest('.accordion-item');
            if (parentItem) {
                parentItem.classList.add('active');
            }

            // Add hide class to the clicked/hovered title
            this.classList.add('hide');
        };

        // Add event listeners for both click and mouseover
        accordionTitles.forEach(title => {
            title.addEventListener('click', handleInteraction);
            title.addEventListener('mouseover', handleInteraction);
        });

        document.addEventListener('DOMContentLoaded', function() {
            // Force browser to recalculate layout after page load
            setTimeout(function() {
                document.querySelectorAll('.accordion-item').forEach(function(item) {
                    item.style.display = 'none';
                    setTimeout(function() { item.style.display = ''; }, 10);
                });
            }, 100);
        });
    }
};
